<template>
  <div>
    <RequestWizard
      v-model:activeStep="activeStep"
      :form-data="formData"
      title="Submit a Freedom of Information Act (FOIA) Request"
    >
      <WelcomeStep />

      <WhoseRecords />

      <MedicareStatus />

      <RecordsType />

      <ContactInfo />

      <RecordDetails />

      <OtherDetails />

      <ReviewStep @go-to-step="activeStep = $event" />

      <template #success-message>
        <div class="small">
          <p>
            Please email
            <a :href="`mailto:${config.supportEmail}`"
            >{{ config.supportEmail }}</a>
            and reference the confirmation number if you need to modify or cancel your request.
          </p>

          Thank you for using the FOIA request portal for Medicare beneficiary
          claims records!
        </div>
      </template>
    </RequestWizard>

    <div class="alert alert-outline-danger mt-5 text-center small">
      <h6 class="mb-3">
        <span class="bi bi-exclamation-triangle-fill"></span>
        INFORMATION NOT RELEASABLE TO THE PUBLIC UNLESS AUTHORIZED BY LAW:</h6>
      <p>This information has not been publicly disclosed and may be privileged
        and confidential. It is for government use only and must not be disseminated,
        distributed, or copied to persons not authorized to receive the information.
        Unauthorized disclosure may result in prosecution to the full extent of the law.
      </p>

      <button class="btn btn-link text-reset"
        @click="showPraDisclosure = !showPraDisclosure"
        :aria-controls="uniqName('pra-disclosure')"
        :aria-expanded="showPraDisclosure"
      >Read PRA Disclosure Statement</button>

      <div v-show-slide="showPraDisclosure"
        :id="uniqName('pra-disclosure')"
      >
        According to the Paperwork Reduction Act of 1995, no persons are required to
        respond to a collection of information unless it displays a valid OMB control
        number. The valid OMB control number for this information collection is 0938-1419
        (Expires 04/30/2029). This is a voluntary information collection. The time required
        to complete this information collection is estimated to average 20 minutes
        (0.33 hours) per response, including the time to review instructions, search
        existing data resources, gather the data needed, and complete and review the
        information collection.  If you have comments concerning the accuracy of the time
        estimate(s) or suggestions for improving this form, please write to: CMS, 7500
        Security Boulevard, Attn: PRA Reports Clearance Officer, Mail Stop C4-26-05,
        Baltimore, Maryland 21244-1850. <b>****CMS Disclosure****</b> Please do not send
        applications, claims, payments, medical records or any documents containing
        sensitive information to the PRA Reports Clearance Office. Please note that any
        correspondence not pertaining to the information collection burden approved under
        the associated OMB control number listed on this form will not be reviewed,
        forwarded, or retained. If you have questions or concerns regarding where to submit
        your documents, please contact the CMS FOIA Office Service Center at (410) 786-5353
        or <a href="mailto:FOIA_Request@cms.hhs.gov">FOIA_Request@cms.hhs.gov</a>.
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import RequestWizard from '@/components/requestWizard';
import ContactInfo from './steps/ContactInfo';
import MedicareStatus from './steps/MedicareStatus';
import OtherDetails from './steps/OtherDetails';
import RecordDetails from './steps/RecordDetails';
import RecordsType from './steps/RecordsType';
import ReviewStep from './steps/ReviewStep';
import WelcomeStep from './steps/WelcomeStep';
import WhoseRecords from './steps/WhoseRecords';
import { formData, nonCommonData } from './requestWizardState';

export default {
  setup: () => ({ formData, nonCommonData }),

  inject: ['config'],

  components: {
    ContactInfo,
    OtherDetails,
    MedicareStatus,
    RecordsType,
    RecordDetails,
    RequestWizard,
    ReviewStep,
    WelcomeStep,
    WhoseRecords
  },

  data: () => ({
    activeStep: null,
    showPraDisclosure: false
  })
};
</script>
